import { HttpHeaders } from "@angular/common/http";

export const REDIRECTPAGE = {
    LOGIN_PAGE: '/auth/login',
    // Rozcestník. Kdo se dostane tam, kam nesmí, se vrací sem — sám se dopočítá,
    // kam ten člověk patří, a u jediné možnosti se přeskočí.
    SELECT_COMPANY_PAGE: '/auth/select-company',
}
/**
 * Klíč přihlašovacího tokenu v `localStorage` (v záložce náhledu kurzu v `sessionStorage`).
 * Číst a zapisovat ho jen přes `auth-storage.ts` (EL-2357).
 */
export const localStorageUser = 'token';
// Accept-Language tu záměrně není — nastavuje ho LanguageInterceptor podle jazyka
// přihlášeného uživatele. Natvrdo zapsaná čeština posílala české hlášky všem.
// Authorization taky ne — ten doplňuje TokenInterceptor z localStorage.
export const headers: HttpHeaders = new HttpHeaders({
  'content-type': 'application/json',
});
